// extracted by mini-css-extract-plugin
export default {"bullet":"Bullet_bullet__Vxzdv","bulletText":"Bullet_bulletText__fwPZH"};